import { apiProvider } from "./core/provider";

const apiAutoSchedule = {};

// All predictions for the company (batch view). Superuser-only.
apiAutoSchedule.getPredictions = function () {
  return apiProvider.get("autoschedule/predictions");
};

// Single-inspection prediction (PreContact "would offer" preview). Superuser-only.
apiAutoSchedule.getPrediction = function (policyNo) {
  return apiProvider.get(`autoschedule/prediction/${policyNo}`);
};

// Tuning config (superuser-only).
apiAutoSchedule.getConfig = function () {
  return apiProvider.get("autoschedule/config");
};

apiAutoSchedule.saveConfig = function (cfg) {
  return apiProvider.put("autoschedule/config", cfg);
};

// Trigger the one-shot simulation pass (superuser-only). Writes simulated routes.
apiAutoSchedule.runSimulation = function () {
  return apiProvider.post("autoschedule/simulate");
};

// Simulated route plans for a date range (superuser-only). from/to are YYYY-MM-DD.
apiAutoSchedule.getSimulatedRoutes = function (from, to) {
  return apiProvider.get(`autoschedule/simulated-routes?from=${from}&to=${to}`);
};

export { apiAutoSchedule };

// Single simulated route for (inspector, date) — Planner "simulated" view.
apiAutoSchedule.getSimulatedRoute = function (inspector, date) {
  return apiProvider.get(`autoschedule/simulated-route?inspector=${inspector}&date=${date}`);
};
